module.exports = __webpack_public_path__ + "static/Waiyee-5e62c5b074c5da5dd071d27cdceb73b9.png";